import { User } from 'types/auth'
import { UserStatusEnum } from 'types/subscription'

export const isNeverPaidUser = (user: User | null | undefined): boolean =>
	user?.status === UserStatusEnum.NEVER_PAID
